import script from "./NotificationPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationPopup.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationPopup.vue?vue&type=style&index=0&id=14bfe2d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bfe2d8"]])

export default __exports__